var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpload1 = function SvgUpload1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    "data-width-40": 32.5,
    viewBox: "0 0 19.6 19.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.72 0a.74.74 0 0 1 .53.22l4 4a.75.75 0 0 1-1.06 1.06l-2.718-2.718.028 11.45a.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75L8.972 2.558 6.25 5.28a.75.75 0 0 1-1.06-1.06l4-4A.74.74 0 0 1 9.72 0m7.03 19.262h-14A2.75 2.75 0 0 1 0 16.512v-3a.75.75 0 1 1 1.5 0v3a1.25 1.25 0 0 0 1.25 1.25h14a1.25 1.25 0 0 0 1.25-1.25v-3a.75.75 0 1 1 1.5 0v3a2.75 2.75 0 0 1-2.75 2.75",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpload1);
export default ForwardRef;